<!--
 * @Description: 监测点跑马灯组件
 * @Author: lefenggang
 * @LastEditors: lefenggang
 * @Date: 2019/8/1
 * @LastEditTime: 2019/8/22 15:25:00
 -->
<template>
    <div class="el-carousel">
        <el-button type="text" icon="e6-icon-arrow-l_line" @click="prevEvent">
        </el-button>
        <div class="el-carousel-list" ref="menu">
            <div
                    class="el-carousel-item"
                    v-for="(item, index) in pointList"
                    :ref="'elItemId' + (item.labelId || item.vehicleId)"
                    :key="index"
                    :style="{
          left: getOffsetLeft(index).left
        }"
                    :class="[idx == index ? 'is-active' : '']"
                    @click="clickPiontEvent(item, index)"
            >
                <!-- <span class="item">{{
                  item.storageAreaName || item.storeName || item.vehicleNum
                }}</span> -->
                <span class="item">
          <slot v-bind:label="item">{{ item.labelName }}</slot>
        </span>
            </div>
        </div>
        <el-button type="text" icon="e6-icon-arrow-r_line" @click="nextEvent">
        </el-button>
    </div>
</template>
<script type="text/babel">
    import storageMixin from "../../mixins/storage-mixin.js";

    export default {
        name: "pointCarousel",
        mixins: [storageMixin],
        props: ["searchData", "locationStorageData", "isIntervalTime", "labelFn"],
        data() {
            return {
                isSearch: false, //是否点击查询按钮
                vLeft: 200, //默认宽度
                idx: 0 //记录当前监测点索引
            };
        },
        computed: {
            //检测数据变化
            pointList() {
                return this.locationStorageData;
            }
        },
        methods: {
            //点击选择监测点
            clickPiontEvent(item, index) {
                //判断时间间隔是否合法
                if (!this.isIntervalTime) {
                    this.$message.warning("时间间隔请输入大于等于0的整数");
                    return;
                }
                //保存当前监测点下标
                this.idx = index;
                //保存当前选中的监测点id
                this.searchData.labelId = item.labelId || item.vehicleId;
                //加载数据
                this.$emit("initData", this.searchData.labelId);
                //是否点击查询按钮
                this.isSearch = false;
            },
            //上翻事件
            prevEvent() {
                let arr = this.$refs.menu.children;
                for (let i = 0; i < arr.length; i++) {
                    let left = parseInt(arr[i].style.left);
                    //判断时间间隔是否合法
                    if (this.isIntervalTime) {
                        arr[i].style.left = left + this.vLeft + "px";
                    }
                }
                //加载数据
                this.loadTableData("prev", arr);
            },
            //下翻事件
            nextEvent() {
                let arr = this.$refs.menu.children;
                for (let i = 0; i < arr.length; i++) {
                    let left = parseInt(arr[i].style.left);
                    let offsetLeft = left - this.vLeft + "px";
                    //判断时间间隔是否合法
                    if (this.isIntervalTime) {
                        arr[i].style.left = offsetLeft;
                    }
                }
                //加载数据
                this.loadTableData("next", arr);
            },
            //加载数据
            loadTableData(type, arr) {
                //判断时间间隔是否合法
                if (!this.isIntervalTime) {
                    this.$message.warning("时间间隔请输入大于等于0的整数");
                    return;
                }
                //判断是上翻还是下翻监测点
                if (type === "prev") {
                    this.pointList.unshift(this.pointList[arr.length - 1]);
                    this.pointList.pop();
                } else {
                    this.pointList.push(this.pointList.shift());
                }
                //初始化监测点位置
                this.initPointOffset(arr);
                //保存当前选中的监测点id
                this.searchData.labelId = this.pointList[this.idx].labelId;
                //加载数据
                this.$emit("initData", this.searchData.labelId);
                //是否点击查询按钮
                this.isSearch = false;
            },
            //初始化监测点位置
            initPointOffset(data) {
                for (let i = 0; i < data.length; i++) {
                    data[i].style.left = i * this.vLeft + "px";
                }
            },
            //获取监测点偏移left
            getOffsetLeft(index) {
                let obj = {};
                let width = this.vLeft * index;
                obj.left = width + "px";
                return obj;
            }
        },
        created() {
        }
    };
</script>

<style lang="scss" scoped>
    .el-carousel {
        height: 36px;
        /deep/ .e6-icon-arrow-l_line {
            color: #909399;
        }
        button {
            cursor: pointer;
            height: 100%;
            padding: 0 5px;
            vertical-align: 12px;
            border-left: solid 1px #e6ebf2;
            box-shadow: 0px 0px 0px #e6ebf2, 0px 0px 0px #e6ebf2,
                /*上边阴影*/
            1px 0px 3px #e6ebf2, /*右边阴影*/
            0px 0px 0px #e6ebf2;
        }
        .el-carousel-list {
            width: calc(100% - 48px);
            height: 100%;
            overflow: hidden;
            display: inline-block;
            position: relative;
            .el-carousel-item {
                position: absolute;
                height: 100%;
                float: left;
                width: 200px;
                cursor: pointer;
                .item {
                    padding: 0px 10px;
                    display: block;
                    border-right: solid 1px #e6ebf2;
                    font-size: 12px;
                    line-height: 36px;
                    height: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
            .el-carousel-item.is-active {
                color: #46bfea;
                // transition: left 0.4s ease;
            }
        }
    }
</style>
